import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import UserIcon from 'Components/common/UserIconComponent';
import SvgIcon from 'Components/svg/SvgIcon';

const QuoteComponent = (props) => {
	let user = props.users[props.userName] || {
		avatar: '',
		userName: ''
	};

	if( user.avatar === '' ) {
		for( let u in props.users ) {
			if( props.users.hasOwnProperty( u ) ) {
				if( props.users[u].userName === props.userName ) {
					user = {
						id: u,
						avatar: props.users[u].avatar,
						userName: props.users[u].userName
					}
				}
			}
		}
	}

	let link_to = props.postId > 0 ?
		<Link to={ `/topics/0?postid=${ props.postId }` } className="link">
			Original Post
			<SvgIcon size="16px" icon="link" />
		</Link> : '',
	userAvatar = user.userName ? <div className="icon"><UserIcon user={ user } layout="quote" /></div> : null;

	return (
		<div className="quote">
			<div className="pointer" />
			<div className="user">
				{ userAvatar }
				<div className="detail">
					{ user.userName ? `${ user.userName } said:` : `Quote:` }
				</div>
				{ link_to }
			</div>
			<div className="body">
				{ props.children }
			</div>
		</div>
	);
};

QuoteComponent.defaultProps = {
	defaultUrl: ( 'https:' === document.location.protocol ? 'https://' : 'http://' ) + 'staticimages.topify.com/default_avatar.png'
};

QuoteComponent.propTypes = {
	postId: PropTypes.number.isRequired,
	userName: PropTypes.string.isRequired
};

// Quote is connected to state since we need the global loaded users data
export default QuoteComponent;



// WEBPACK FOOTER //
// ./src/components/posts/QuoteComponent.js